import { Scene } from "onearm";
import { SuperContainer } from "onearm";

export class GameBackground extends Scene {
    constructor({ screen, spine = "BackgroundAnimation", portraitAnimation, landscapeAnimation }) {
        super({ name: "GameBackground", layer: "background" });
        this.screen = screen;

        this.changeAnimation({ spine, portraitAnimation, landscapeAnimation });
    }

    changeAnimation({spine = "BackgroundAnimation", portraitAnimation, landscapeAnimation}) {
        if (this.landsacpe) {
            this.landsacpe.stop();
            this.landsacpe.destroy();
        }
        if (this.portrait) {
            this.portrait.stop();
            this.portrait.destroy();
        }

        this.landsacpe = new BackgroundAnimation({
            spine,
            animation: landscapeAnimation,
            loop: true,
            x: "50%",
            y: "50%",
            zone: this.screen.zone,
        });
        this.portrait = new BackgroundAnimation({
            spine,
            animation: portraitAnimation,
            loop: true,
            x: "50%",
            y: "50%",
            fit: "width",
            zone: this.screen.zone,
        });
        this.addChild(this.landsacpe);
        this.addChild(this.portrait);

        this.landsacpe.play();
        this.portrait.stop();
        this.isLandscape = undefined;
        this.setMode(this.screen.mode);

    }

    setMode(mode) {
        const isLandscape = mode !== "desktop" && mode !== "landscape";
        const isMobile = mode !== "desktop";

        if (this.isLandscape !== isLandscape) {
            if (isLandscape) {
                this.landsacpe.stop();
                this.landsacpe.visible = false;
                this.portrait.play();
                this.portrait.visible = true;
            } else {
                this.landsacpe.play();
                this.landsacpe.visible = true;
                this.portrait.stop();
                this.portrait.visible = false;
            }
            this.isLandscape = isLandscape;
        }
    }

    onScreenResize(event) {
        const { mode } = event;

        this.setMode(mode);
    }

    stop() {
        this.landsacpe.stop();
        this.portrait.stop();
    }
}

export class BackgroundAnimation extends SuperContainer {
    constructor({ spine, loop = true, x = "50%", y = "50%", animation, fit = "height", zone}) {
        super({ name: "BackgroundAnimation" });

        this.bg = this.createObject("SpineAnimation", {
            spine,
            animation,
            loop,
            x,
            y,
        });

        this.bg.goToStart();

        this.bgWidth = this.bg.width;
        this.bgHeight = this.bg.height;

        this.apply(zone);
    }

    onScreenResize(event) {
        const { zone } = event;

        if (!this.visible) {
            return;
        }

        this.apply(zone);
    }

    apply(zone) {
        if (this.fit === "height") {
            this.scaleToFillHeight(zone);
        } else {
            this.scaleToFillWidth(zone);
        }
    }

    /**
     * Масштабирует фон чтобы заполнить всю высоту экрана
     * При недостатке ширины растягивает по ширине (может выйти за рамки по высоте)
     */
    scaleToFillHeight(zone) {
        const bgOriginalWidth = this.bgWidth;
        const bgOriginalHeight = this.bgHeight;
        const scaleY = zone.fullScreen.height / bgOriginalHeight;
        const scaleX = zone.fullScreen.width / bgOriginalWidth;

        // Всегда заполняем высоту экрана (scaleY)
        // Если ширина недостаточна, используем больший масштаб (scaleX)
        const scale = Math.max(scaleY, scaleX);

        this.bg.scale.x = scale;
        this.bg.scale.y = scale;
    }

    /**
     * Масштабирует фон чтобы заполнить всю ширину экрана
     * При недостатке высоты растягивает по высоте (может выйти за рамки по ширине)
     */
    scaleToFillWidth(zone) {
        const bgOriginalWidth = this.bgWidth;
        const bgOriginalHeight = this.bgHeight;
        const scaleX = zone.fullScreen.width / bgOriginalWidth;
        const scaleY = zone.fullScreen.height / bgOriginalHeight;

        // Всегда заполняем ширину экрана (scaleX)
        // Если высота недостаточна, используем больший масштаб (scaleY)
        const scale = Math.max(scaleX, scaleY);

        this.bg.scale.x = scale;
        this.bg.scale.y = scale;
    }

    play() {
        this.bg.play(true);
    }

    stop() {
        this.bg.stop();
    }
}
